export default __webpack_public_path__ + "img/1dbb0f96616d10ef08f5db799127be34.svg";